import React from "react";
import { Save, X } from "lucide-react";

const EditFloatingActions = ({
    onSave,
    onCancel,
    disabled = false,
    saveLabel = "Зберегти",
    cancelLabel = "Скасувати",
}) => {
    if (!onSave && !onCancel) return null;

    return (
        <div className="edit-floating-actions" role="toolbar" aria-label="Дії редагування">
            {onCancel ? (
                <button
                    type="button"
                    className="edit-floating-action is-cancel"
                    onClick={onCancel}
                    title={cancelLabel}
                    aria-label={cancelLabel}
                    disabled={disabled}
                >
                    <X size={20} />
                </button>
            ) : null}
            {onSave ? (
                <button
                    type="button"
                    className="edit-floating-action is-primary-save"
                    onClick={onSave}
                    title={saveLabel}
                    aria-label={saveLabel}
                    disabled={disabled}
                >
                    <Save size={20} />
                </button>
            ) : null}
        </div>
    );
};

export default EditFloatingActions;
